import styled from "styled-components/macro";
import {
  BUTTON_BACKGROUND_COLOR,
  BUTTON_HOVER_SHADOW_COLOR,
  BUTTON_DISABLED_COLOR,
  BUTTON_ACTIVE_COLOR,
  BUTTON_DEFAULT_WIDTH,
  BUTTON_DEFAULT_HEGITH,
  SETTINGS_TEXT_COLOR,
} from "../../helpers/Const";

export interface IButtonProps {
  width?: number;
  height?: number;
}

export const GenericButton = styled.button<IButtonProps>`
  flexBasis: ${props => props.width ?? BUTTON_DEFAULT_WIDTH}px;
  width: ${props => props.width ?? BUTTON_DEFAULT_WIDTH}px;
  height: ${props => props.height ?? BUTTON_DEFAULT_HEGITH}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: white;
  font-weight: bold;

  background: ${BUTTON_BACKGROUND_COLOR};
  border: 0;
  box-shadow: inset 0 0 0 3px #00000000;

  &:focus {
    outline: 0;
  }

  &:hover {
    box-shadow: inset 0 0 0 3px ${BUTTON_HOVER_SHADOW_COLOR};
  }
  &:disabled {
    background: ${BUTTON_DISABLED_COLOR};
    cursor: default;
  }
  &:active {
    background: ${BUTTON_ACTIVE_COLOR};
    box-shadow: inset 0 0 0 3px #00000000;
    color: white;
  }
`;

export const GridGenericButton = styled.button<IButtonProps>`
  width: calc(100% - 10px);
  height: 42px;
  line-height: 42px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: white;
  font-weight: bold;

  background: ${BUTTON_BACKGROUND_COLOR};
  border: 0;
  box-shadow: inset 0 0 0 3px #00000000;

  &:focus {
    outline: 0;
  }

  &:hover {
    box-shadow: inset 0 0 0 3px ${BUTTON_HOVER_SHADOW_COLOR};
  }
  &:disabled {
    background: ${BUTTON_DISABLED_COLOR};
    cursor: default;
  }
  &:active {
    background: ${BUTTON_ACTIVE_COLOR};
    box-shadow: inset 0 0 0 3px #00000000;
    color: white;
  }
`;

export const SecondaryButton = styled(GenericButton)`
  background: white;
  color: ${SETTINGS_TEXT_COLOR};
  font-weight: normal;
  box-shadow: inset 0 0 0 1px ${BUTTON_BACKGROUND_COLOR};
  &:hover {
    box-shadow: inset 0 0 0 1px ${BUTTON_HOVER_SHADOW_COLOR};
  }
  &:disabled {
    background: white;
    color: ${BUTTON_DISABLED_COLOR};
    box-shadow: inset 0 0 0 1px ${BUTTON_DISABLED_COLOR};
    cursor: default;
  }
  &:active {
    box-shadow: inset 0 0 0 1px #00000000;
  }
`;

export const GridSecondaryButton = styled(GridGenericButton)`
  background: white;
  color: ${SETTINGS_TEXT_COLOR};
  font-weight: normal;
  box-shadow: inset 0 0 0 1px ${BUTTON_BACKGROUND_COLOR};
  &:hover {
    box-shadow: inset 0 0 0 1px ${BUTTON_HOVER_SHADOW_COLOR};
  }
  &:disabled {
    background: white;
    color: ${BUTTON_DISABLED_COLOR};
    box-shadow: inset 0 0 0 1px ${BUTTON_DISABLED_COLOR};
    cursor: default;
  }
  &:active {
    box-shadow: inset 0 0 0 1px #00000000;
  }
`;

export const SettingsButton = styled.button`
  height: ${(props: IButtonProps) => (props.height ? props.height : 32)}px;
  width: ${(props: IButtonProps) => (props.width ? props.width : 150)}px;
  cursor: pointer;
`;

export interface IIconSettingsButtonProps {
  image?: string;
  imageHover?: string;
  imagePressed?: string;
  imageDisabled?: string;
}

export const IconSettingsButton50x50 = styled.button`
  width: 50px;
  height: 50px;
  display: flex;
  align-content: center;
  align-items: center;
  flex: 0 0 50px;
  cursor: pointer;
  border: 0;
  background-size: auto;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0;

  background-image: url(${(props: IIconSettingsButtonProps) => props.image});

  &:hover {
    background-image: url(${(props: IIconSettingsButtonProps) => props.imageHover});
  }
  &:active {
    background-image: url(${(props: IIconSettingsButtonProps) => props.imagePressed});
  }
  &:disabled {
    background-image: url(${(props: IIconSettingsButtonProps) => props.imageDisabled});
    cursor: default;
  }
  &:focus {
    outline: 0;
  }
`;

export const IconSettingsButton22x22 = styled(IconSettingsButton50x50)`
  width: 22px;
  height: 22px;
  flex-basis: 22px;
`;

export const IconSettingsButton32x32 = styled(IconSettingsButton50x50)`
  width: 32px;
  height: 32px;
  flex-basis: 32px;
`;

export const IconSettingsButton33x32 = styled(IconSettingsButton50x50)`
  width: 33px;
  height: 32px;
  flex-basis: 33px;
`;


export const SVG_Container_50x50 = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  flex: 0 0 50px;
  cursor: pointer;
  border: 0;
  padding: 0;

  align-content: center;
  align-items: center;
  justify-content: center;

  svg {
    width: 50px;
    height: 50px;
  }

  svg:hover {
    stroke: #7bc62d;
  }

  &:hover {
    filter: 
  }

  &:active svg {
    stroke: #00b341;
  }
  &:disabled {
    cursor: default;
  }
  &:focus {
    outline: 0;
  }
`;


export const Icon_SVG_22x22 = styled(SVG_Container_50x50)`
  width: 22px;
  height: 22px;
  flex-basis: 22px;
`;

export const Icon_SVG_24x24 = styled(SVG_Container_50x50)`
  width: 24px;
  height: 24px;
  flex-basis: 24px;
`;

export const Icon_SVG_32x32 = styled(SVG_Container_50x50)`
  width: 32px;
  height: 32px;
  flex-basis: 32px;
`;